import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@cellectenergy/cellect-react-components";
import { useTranslation } from "react-i18next";
import { MainContainer, VideoContainer } from "./introAbout.styles";
import Image from "next/image";

const IntroAbout = () => {
  const theme = useTheme();
  const { t } = useTranslation("global");

  return (
    <MainContainer>
      <VideoContainer>
        <Image
          className="custom-video"
          src="/assets/about/intro.webp"
          alt="about intro, sea"
          fill={true}
          priority
        />
      </VideoContainer>
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-start"
        flexDirection={"column"}
        height={"100%"}
        maxWidth={theme.breakpoints.values.lg}
        margin={"0 auto"}
        padding={{ xs: "0 1rem 0", md: "0 1.5rem 0", lg: "0 2rem 0" }}
        gap={{ xs: "1rem", md: "2rem", gap: "2rem" }}
      >
        <Grid container>
          <Grid
            lg={6.5}
            md={7.6}
            xs={12}
            item
            position={"relative"}
            zIndex={1}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"flex-end"}
            alignItems={"flex-start"}
            gap={{ xs: "1rem", md: "1.5rem" }}
          >
            <Typography
              variant="display-medium"
              fontWeight={500}
              color={theme.palette.common.corporateColors.primary.white}
            >
              {t("about.intro.title")}
            </Typography>
            <Typography
              variant="title-large"
              fontWeight={400}
              color={theme.palette.common.corporateColors.primary.white}
            >
              {t("about.intro.description")}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </MainContainer>
  );
};

export default IntroAbout;
